/**
 * @generated SignedSource<<8be66422eda49557ebc1d105f8913f9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InviteOverviewUserPromotionHistoryQuery$variables = {
  promotionCode: string;
};
export type InviteOverviewUserPromotionHistoryQuery$data = {
  readonly getRefundUserPromotionHistory: {
    readonly count: number | null | undefined;
  };
};
export type InviteOverviewUserPromotionHistoryQuery = {
  response: InviteOverviewUserPromotionHistoryQuery$data;
  variables: InviteOverviewUserPromotionHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "promotionCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "promotionCode",
        "variableName": "promotionCode"
      }
    ],
    "concreteType": "RefundUserPromotionHistoryOutput",
    "kind": "LinkedField",
    "name": "getRefundUserPromotionHistory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InviteOverviewUserPromotionHistoryQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InviteOverviewUserPromotionHistoryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2346d74cf5794ca70ef65339fd8546f",
    "id": null,
    "metadata": {},
    "name": "InviteOverviewUserPromotionHistoryQuery",
    "operationKind": "query",
    "text": "query InviteOverviewUserPromotionHistoryQuery(\n  $promotionCode: String!\n) {\n  getRefundUserPromotionHistory(promotionCode: $promotionCode) {\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e9bfcae53a5c41323ca9d4c8ee5dbb2";

export default node;
